import styled from 'styled-components';

export const LandingContainer = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;

export const Hero = styled.section`
  display: flex;
  min-height: 100vh;
  padding: 120px 5% 60px;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
    gap: 60px;
  }

  @media (max-width: 768px) {
    padding: 100px 5% 40px;
  }
`;

export const HeroContent = styled.div`
  max-width: 600px;
  flex: 1;

  @media (max-width: 1024px) {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Heading = styled.h1`
  color: var(--primary);
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.1;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const Subheading = styled.p`
  font-size: 1.25rem;
  line-height: 1.6;
  color: var(--subtle-text);
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 1.125rem;
  }
`;

export const AppStoreBadge = styled.a`
  display: inline-block;

  img {
    height: 48px;
  }
`;

export const PhoneDisplay = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FeaturesSection = styled.section`
  padding: 100px 5%;
  text-align: center;
  background-color: var(--background);
`;

export const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 4rem auto 0;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Feature = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const FeatureIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1.5rem;
`;

export const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

export const FeatureDescription = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: var(--subtle-text);
`;

export const DownloadSection = styled.section`
  padding: 100px 5%;
  background-color: var(--background);
`;

export const DownloadContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4rem;
  max-width: 1000px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 2rem;
  }
`;

export const QRCodeContainer = styled.div`
  padding: 2rem;
  background-color: white;
  border-radius: 24px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
`;

export const QRCode = styled.img`
  width: 180px;
  height: 180px;
`;

export const DownloadText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ScanText = styled.p`
  font-size: 1.125rem;
  line-height: 1.6;
  color: var(--subtle-text);
  margin-bottom: 2rem;
`;
